import { Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";

import { GlobalComponent, Result } from "../environments/global";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  txtPassword: string = "";
  isSpinning: boolean = false;

  // ################################################
  // CLASS: CONSTRUCTOR
  constructor(
    private router: Router,
    public g: GlobalComponent,
    private message: NzMessageService
  ) {}

  // ################################################
  // CLASS: ON INIT
  ngOnInit() {}

  // ################################################
  // LOGIN
  login() {
    this.g.userLogin = {
      password: this.txtPassword,
      logged: false,
      restricted: false,
      onlyorders: false
    };
    this.isSpinning = true;
    this.g.login().subscribe(
      (res: Result) => {
        this.isSpinning = false;
        if (res.error === false) {
          this.message.success("Codice accettato");

          this.g.userLogin = res.data;
          sessionStorage.setItem("webcheck", JSON.stringify(this.g.userLogin));

          this.router.navigateByUrl("/home");
        } else {
          this.message.warning(res.message);
        }
      },
      (error: HttpErrorResponse) => {
        this.isSpinning = false;
        this.message.warning(
          'Si è vericato un errore non previsto:<br>"' + error.statusText + '"'
        );
      }
    );
  }
}
